import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function TransformationSection() {
  const before = ['Ore perse a pianificare', 'Stress della domenica sera', 'Improvvisazione in aula', 'Nessun sistema chiaro', 'Allieve che se ne vanno'];
  const after = ['5 minuti di ripasso', 'Lezioni sempre pronte', 'Sicurezza in aula', 'Un metodo che funziona', 'Allieve fedeli e soddisfatte'];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-185">
      <div className="max-w-5xl mx-auto" data-id="element-186">
        <div className="flex flex-col md:flex-row gap-12 items-center mb-16" data-id="element-187">
          <div className="flex-1" data-id="element-188">
            <h2 className="text-4xl md:text-5xl font-black text-brand-text leading-[1.1] tracking-tight mb-6 text-balance" data-id="element-189">
              Da un'insegnante sopraccarica a una{' '}
              <span className="italic text-brand-green" data-id="element-190">guida ispirata.</span>
            </h2>
            <div className="flex items-center gap-4 bg-white/60 p-4 rounded-2xl inline-flex" data-id="element-191">
              <span className="text-4xl font-serif font-bold text-brand-terracotta" data-id="element-192">
                150+
              </span>
              <span className="text-sm text-brand-gray font-medium max-w-[150px] leading-tight" data-id="element-193">
                risorse pronte all'uso a tua disposizione.
              </span>
            </div>
          </div>

          <div className="flex-1 w-full bg-white rounded-3xl shadow-sm border border-brand-creamDark grid grid-cols-2 overflow-hidden" data-id="element-194">
            {/* ANTES */}
            <div className="bg-[#faf6f1] p-5 md:p-7" data-id="element-195">
              <div className="flex items-center gap-2 mb-6" data-id="element-196">
                <XCircle className="w-6 h-6 text-brand-terracotta shrink-0" data-id="element-197" />
                <h3 className="text-xs md:text-sm font-bold uppercase tracking-wider text-brand-terracotta leading-tight" data-id="element-198">
                  Prima
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-199">
                {before.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-brand-text" data-id="element-200">
                    <XCircle className="w-5 h-5 text-brand-terracotta/70 shrink-0 mt-0.5" data-id="element-201" />
                    <span className="text-sm md:text-base font-medium leading-snug" data-id="element-202">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* CON YOGA LISTA */}
            <div className="bg-[#f1f5f2] p-5 md:p-7 border-l border-brand-creamDark" data-id="element-203">
              <div className="flex items-center gap-2 mb-6" data-id="element-204">
                <CheckCircle2 className="w-6 h-6 text-brand-green shrink-0" data-id="element-205" />
                <h3 className="text-xs md:text-sm font-bold uppercase tracking-wider text-brand-green leading-tight" data-id="element-206">
                  Dopo
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-207">
                {after.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-brand-text" data-id="element-208">
                    <CheckCircle2 className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-209" />
                    <span className="text-sm md:text-base font-semibold leading-snug" data-id="element-210">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex justify-center gap-4 md:gap-8" data-id="element-211">
          {[{
          v: '+150',
          l: 'Risorse'
        }, {
          v: '24/6',
          l: 'Accesso'
        }, {
          v: '100%',
          l: "Pronto all'uso"
        }].map((s, i) => <div key={i} className="bg-white px-6 py-3 rounded-full shadow-sm border border-brand-creamDark flex flex-col items-center" data-id="element-212">
              <span className="font-serif font-bold text-xl text-brand-text" data-id="element-213">
                {s.v}
              </span>
              <span className="text-[10px] uppercase tracking-wider text-brand-gray" data-id="element-214">
                {s.l}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}